export interface RopeLandingPageData {
  id: number;
  status: string;
  projectCode: string;
  referenceId: string;
  projectName: string;
  clientName: string;
  office: string;
  entity: string;
  startDate: Date;
  uploadStatus: string;
  uploadVersion: number;
  inactive: boolean;
  flags: string[];
  uploadId: number;
  uploadedBy: string;
  uploadedById: number;
}

export interface RopeLandingPageDataDto {
  a: number; // rope id
  b: string; // status
  c: string; // Project Code
  d: string; // Reference ID
  e: string; // Project Name
  f: string; // Client Name
  g: string; // Office
  h: Date; // startDate
  i: string; // upload Status
  j: number; // upload Version
  k: boolean; // inactive
  l: string; // flags
  m: number; // upload id
  n: string; // uploaded By
  o: number; // uploaded By id
}

export interface RopeMessageDto {
  a: number; // id
  b: Date; // created at
  c: string; // created by
  d: number; // created by id
  e: string; // level
  f: string; // type
  g: string; // message
}

export interface RopeMessage {
  id: number;
  createdAt: Date;
  createdBy: string;
  createdById: number;
  level: string;
  type: string;
  message: string;
}

export interface RopeLog {
  id: number;
  createdAt: Date;
  createdBy: string;
  createdById: number;
  fileName: string;
  message: string;
  description: string;
}

export interface RopeLogDto {
  a: number; // id
  b: Date; // created at
  c: string; // created by
  d: number; // created by id
  e: string; // fileName
  f: string; // message
  g: string; // description
}

export interface Rope {
  id: number;
  status: string;
  project_code: string;
  project_uid: string;
  project_name: string;
  client_name: string;
  office: string;
  start_date: Date;
  flags: string;
  entity: string;
}

export interface RopeUpload {
  id: number;
  created_at: Date;
  updated_at: Date;
  created_by_id: number;
  updated_by_id: number;
  created_by: string;
  updated_by: string;
  comment: string;
  version: number;
  status: string;
  message_count: number;
  original_filename: string;
  file_version: string;
}

export interface RopeUploadsPageData {
  rope: Rope;
  uploads: RopeUpload[];
}

export interface RopeImportDto {
  rope_id: number;
  upload_id: number;
  project_code: string;
  project_name: string;
  start_date: Date;
  projector: boolean;
}

export const RopeDetailModalWidth = 1000;
export const RopeDetailModalKeyClass = "rope-detail-modal-key-column";
export const RopeDetailModalKeyWidth = 150;

export const RopeFlagDynamics = "DYNAMICS";
export const RopeFlagCommercialReviewEmailSend = "CR_EMAIL_SENT";
export const RopeUploadStatusDeletable: string[] = ["Ready", "Error"];
export const RopeStatusImportable: string[] = ["Planning"];
